<script lang="ts">
  import { ArtAssetFormat } from '@do/models';

  import { formatOptions, type FormatOption } from '@shared/configs';
  import { Icon } from '@shared/ui/icon';
  import { cn } from '@shared/utils';

  export let format: ArtAssetFormat;

  const styleClasses = {
    '3d_object':
      'bg-orange-400/10 text-orange-800 border-orange-300 dark:text-orange-300 dark:bg-orange-400/10 dark:border-orange-300/30',
    motion_art:
      'bg-indigo-400/10 text-indigo-800 border-indigo-300 dark:text-indigo-300 dark:bg-indigo-400/10 dark:border-indigo-300/30',
    json: 'bg-cyan-400/10  text-cyan-800 border-cyan-300 dark:text-cyan-300 dark:bg-cyan-400/10 dark:border-cyan-300/30',
  } as const;

  let option: FormatOption | undefined;

  $: option = formatOptions.find((option) => option.value === format);
</script>

{#if option && option.value !== ArtAssetFormat.Image && option.icon && option.text}
  <div
    class="{cn(
      'inline-flex items-center gap-1.5 rounded-md border px-1.5 py-1.5 text-sm font-medium transition-colors',
      styleClasses[option.value],
      {
        'pointer-events-none cursor-default': true,
      },
    )}"
  >
    <Icon name="{option.icon}" />
    <span>{option.text}</span>
  </div>
{/if}
